import { motionAllowed } from '../../lib/motion';

/**
 * What each of the editor's tools does with its icon as it's used, to say what just happened:
 * Undo turns back and Redo forward, Import lifts its arrow up and lets it settle, Paste
 * presses down, Copy squeezes and springs, Read aloud swells, and Clear shakes.
 */
const MOTIONS = {
  undo: [
    { transform: 'rotate(0)' },
    { transform: 'rotate(-55deg)', offset: 0.35 },
    { transform: 'rotate(6deg)', offset: 0.75 },
    { transform: 'rotate(0)' },
  ],
  redo: [
    { transform: 'rotate(0)' },
    { transform: 'rotate(55deg)', offset: 0.35 },
    { transform: 'rotate(-6deg)', offset: 0.75 },
    { transform: 'rotate(0)' },
  ],
  import: [
    { transform: 'translateY(0)' },
    { transform: 'translateY(-5px)', offset: 0.35 },
    { transform: 'translateY(1px)', offset: 0.75 },
    { transform: 'translateY(0)' },
  ],
  paste: [
    { transform: 'translateY(0) scale(1)' },
    { transform: 'translateY(3px) scale(0.84)', offset: 0.3 },
    { transform: 'translateY(-1px) scale(1.06)', offset: 0.7 },
    { transform: 'translateY(0) scale(1)' },
  ],
  copy: [
    { transform: 'scale(1)' },
    { transform: 'scale(0.72)', offset: 0.3 },
    { transform: 'scale(1.14)', offset: 0.65 },
    { transform: 'scale(1)' },
  ],
  speak: [
    { transform: 'scale(1)' },
    { transform: 'scale(1.2)', offset: 0.3 },
    { transform: 'scale(0.94)', offset: 0.65 },
    { transform: 'scale(1)' },
  ],
  clear: [
    { transform: 'rotate(0)' },
    { transform: 'rotate(-14deg)', offset: 0.2 },
    { transform: 'rotate(11deg)', offset: 0.45 },
    { transform: 'rotate(-6deg)', offset: 0.7 },
    { transform: 'rotate(0)' },
  ],
} satisfies Record<string, Keyframe[]>;

export type ToolMotion = keyof typeof MOTIONS;

/**
 * Plays a tool's motion on the icon of its button, the one marked data-tool with its name
 * within `tools`. Added to what the icon is already doing, such as growing under the pointer.
 */
export function playTool(tools: HTMLElement | null, tool: ToolMotion): void {
  if (!motionAllowed()) return;
  tools
    ?.querySelector(`[data-tool="${tool}"] > svg`)
    ?.animate(MOTIONS[tool], { duration: 480, easing: 'ease-out', composite: 'add' });
}
